import { lazy } from 'react';
import { ShoppingCart } from 'lucide-react';
import { defineFrontendModule } from '../../core/modules/types';

export default defineFrontendModule({
  id: 'thomann',
  name: 'Thomann B-Ware',

  routes: [
    { path: 'technik/thomann-bware', menuKey: 'technik.thomann-bware', element: lazy(() => import('./pages/ThomannBWare')) },
  ],

  nav: [{ menuKey: 'technik.thomann-bware', path: '/technik/thomann-bware', defaultIcon: ShoppingCart }],
});
